import './styles/Login.scss'
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import checkIcon from './assets/icons/check.png';
import errorIcon from './assets/icons/error.png';
import Pool from './UserPool.js';
import { CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import CheckoutButton from './CheckoutButton.js';

export default function SignUp({ setPage }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [stage, setStage] = useState(0);
    const [form, setForm] = useState({
        name: '',
        phoneNumber: '',
        email: '',
        password: '',
        confirmPassword: '',
        cognitoUserId: ''
    });
    const location = useLocation();
    const navigate = useNavigate();

    const products = [
        {
            "product_name": "FireWatch Web Premium (Monthly)",
            "product_description": "Full Access to FireWatch web premium features, including AI Wildfire Modeling and Simulations, Custom Areas/Alerts, Advanced Current Fire Data, and more.",
            "price_id": process.env.REACT_APP_STRIPE_MONTHLY_SUBSCRIPTION_PRICE_ID_PRODUCTION,
            "currency": "usd",
            "unit_amount": 999,
            "interval": "month",
            "interval_count": 1,
            "lookup_key": null,
            "metadata": {}
        },
        {
            "product_name": "FireWatch Web Premium (Annual)",
            "product_description": "Full Access to FireWatch web premium features, including AI Wildfire Modeling and Simulations, Custom Areas/Alerts, Advanced Current Fire Data, and more.",
            "price_id": process.env.REACT_APP_STRIPE_ANNUAL_SUBSCRIPTION_PRICE_ID_PRODUCTION,
            "currency": "usd",
            "unit_amount": 8399,
            "interval": "year",
            "interval_count": 1,
            "lookup_key": null,
            "metadata": {}
        },
    ]

    useEffect(() => {
        // Check if user came from "View Subscription Plans" button
        if (sessionStorage.getItem('goToSubscriptions')) {
            sessionStorage.removeItem('goToSubscriptions');
            // Get the existing cognitoUserId from login
            const existingCognitoUserId = sessionStorage.getItem('existingCognitoUserId');
            if (existingCognitoUserId) {
                setForm({...form, cognitoUserId: existingCognitoUserId});
                sessionStorage.removeItem('existingCognitoUserId');
            }
            setStage(2); // Go directly to subscription plans
        }
    }, []);
      

    const signUp = () => {
        setLoading(true);

        const attributeList = [
            new CognitoUserAttribute({ Name: 'email', Value: form.email}),
            new CognitoUserAttribute({ Name: 'name', Value: form.name}),
            new CognitoUserAttribute({ Name: 'phone_number', Value: `+1${form.phoneNumber}`}),
        ];

        Pool.signUp(form.email, form.password, attributeList, null, (err, data) => {
            if (err) {
                setLoading(false);
                setError(`Trouble signing up: ${err}`);
            }
            else {
                axios.post('https://firewatch-api.space-eyes.com/user/register', {
                    cognito_user_id: data.userSub,
                    full_name: form.name,
                    email: data.user.username,
                    phone_number: form.phoneNumber
                }).then((res) => {
                    setLoading(false);
                    setStage(2);
                    setForm({...form, cognitoUserId: data.userSub});
                }).catch((err) => {
                    console.log(err);
                    setLoading(false);
                    setError('Trouble signing up. Please try again');
                })
            }
        });
    }

    const stageSwitch = () => {
        switch (stage) {
            case 0: return <div className='login-right'>
                <form className='login-right-container' style={{height: '600px'}}>
                    <div className='login-right-container-title'>Sign Up</div>
                    {error && <div className='login-right-container-error'>{error}</div>}
                    <div className='login-right-container-subtitle'>Full Name</div>
                    <div className='login-right-container-field'>
                        <div className='login-right-container-field-name'/>
                        <input name='full_name' className='login-right-container-field-input' placeholder='John Doe' onChange={(e) => setForm({...form, name: e.target.value})}/>
                    </div>
                    <div className='login-right-container-subtitle'>Email Address</div>
                    <div className='login-right-container-field'>
                        <div className='login-right-container-field-email'/>
                        <input name='email' className='login-right-container-field-input' placeholder='johndoe@email.com' onChange={(e) => setForm({...form, email: e.target.value})}/>
                    </div>
                    <div className='login-right-container-subtitle'>Phone Number</div>
                    <div className='login-right-container-field'>
                        <div className='login-right-container-field-phone'/>
                        <input name='phone_number' className='login-right-container-field-input' placeholder='123456789' onChange={(e) => setForm({...form, phoneNumber: e.target.value})}/>
                    </div>
                    <div className='login-right-container-button' onClick={() => {
                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        const validatedEmail = emailRegex.test(form.email);

                        const phoneRegex = /^\d{10}$/;
                        const validatePhone = phoneRegex.test(form.phoneNumber);

                        if(validatePhone && validatedEmail) {
                            setStage(1);
                            setError(false);
                        } else {
                            if(!validatePhone && !validatedEmail) {
                                setError('Invalid email & phone number');
                            } else {
                                if(!validatePhone) {
                                    setError('Invalid phone number');
                                } else if(!validatedEmail) {
                                    setError('Invalid email');
                                }
                            }
                        }
                    }}>Continue</div>
                    <div className='login-right-container-text'>Already have an account? Click <b className='login-right-container-link' onClick={() => setPage(0)}>here</b> to login.</div>
                    <div className='login-right-container-text'>Space-Eyes, Inc. is a US based company and only conducts business with US allies.</div>
                </form>
                <div className='login-right-logo'/>
            </div>
            case 1: return <div className='login-right'>
                <form className='login-right-container'>
                    {
                        loading ? <div className='login-right-container-subs' style={{height: '400px', justifyContent: 'center', alignItems: 'center'}}>
                            <div className="lds-ring" style={{marginBottom: '1rem', borderColor: 'white'}}><div></div><div></div><div></div><div></div></div>
                        </div>
                        :
                        <>
                            <div className='login-right-container-title'>Sign Up</div>
                            {error && <div className='login-right-container-error'>{error}</div>}
                            <div className='login-right-container-subs-success-subtext' style={{marginTop: '-1rem', textAlign: 'left'}}>Your password be at minimum 8 characters long and must contain at least 1 number, special character, uppercase letter, and lowercase letter.</div>
                            <div className='login-right-container-subtitle'>Password</div>
                            <div className='login-right-container-field'>
                                <div className='login-right-container-field-lock'/>
                                <input name='password' type='password' className='login-right-container-field-input' placeholder='password' onChange={(e) => setForm({...form, password: e.target.value})}/>
                            </div>
                            <div className='login-right-container-subtitle'>Confirm Password</div>
                            <div className='login-right-container-field'>
                                <div className='login-right-container-field-lock'/>
                                <input name='confirm_password' type='password' className='login-right-container-field-input' placeholder='password' onChange={(e) => setForm({...form, confirmPassword: e.target.value})}/>
                            </div>
                            <div className='login-right-container-button' onClick={() => {
                                const hasNumber = /\d/;
                                const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;
                                const hasUppercase = /[A-Z]/;
                                const hasLowercase = /[a-z]/;
                        
                                const validatePassword = hasNumber.test(form.password) && hasSpecialChar.test(form.password) && hasUppercase.test(form.password) && hasLowercase.test(form.password);

                                if(validatePassword && (form.password === form.confirmPassword)) {
                                    setError(false);
                                    signUp();
                                } else {
                                    if(!validatePassword && (form.password != form.confirmPassword)) {
                                        setError('Invalid password and password do not match');
                                    } else {
                                        if(!validatePassword) {
                                            setError('Invalid password');
                                        } else if(form.password != form.confirmPassword) {
                                            setError('Passwords do not match');
                                        }
                                    }
                                }
                            }}>Create Account</div>
                            <div className='login-right-container-text'><b className='login-right-container-link' onClick={() => setStage(0)}>Back to personal details</b></div>
                            <div className='login-right-container-text'>Already have an account? Click <b className='login-right-container-link'>here</b> to login.</div>
                            <div className='login-right-container-text'>Space-Eyes, Inc. is a US based company and only conducts business with US allies.</div>
                        </>
                    }
                </form>
                <div className='login-right-logo'/>
            </div>
            case 2: return <div className='login-right'>
                <form className='login-right-container' style={{height: '700px', overflow: 'auto', scrollbarWidth: 'thin', scrollbarColor: 'rgba(0, 128, 255, 0) transparent'}}>
                    <div className='login-right-container-title'>Choose Your Plan</div>
                    {error && <div className='login-right-container-error'>{error}</div>}
                    
                    
                    <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem', paddingTop: '10px'}}>
                        {products.map((product, index) => {
                            const price = (product.unit_amount / 100).toFixed(2);
                            const isAnnual = product.interval === 'year';
                            const savings = isAnnual ? 'Save 30%' : '';
                            
                            return (
                                <div key={product.product_id} style={{
                                    border: '2px solid #0080ff',
                                    borderRadius: '12px',
                                    padding: '1.5rem',
                                    backgroundColor: 'rgba(0, 128, 255, 0.05)',
                                    position: 'relative',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer'
                                }}>
                                    {savings && (
                                        <div style={{
                                            position: 'absolute',
                                            top: '-10px',
                                            right: '20px',
                                            backgroundColor: 'orange',
                                            color: '#000',
                                            padding: '4px 12px',
                                            borderRadius: '20px',
                                            fontSize: '0.8rem',
                                            fontWeight: 'bold'
                                        }}>
                                            {savings}
                                        </div>
                                    )}
                                    
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        marginBottom: '1rem'
                                    }}>
                                        <div>
                                            <h3 style={{
                                                color: 'white',
                                                margin: '0 0 0.5rem 0',
                                                fontSize: '1.2rem',
                                                fontWeight: '600'
                                            }}>
                                                {product.product_name}
                                            </h3>
                                            <p style={{
                                                color: '#b0b0b0',
                                                margin: '0',
                                                fontSize: '0.9rem',
                                                lineHeight: '1.4'
                                            }}>
                                                {product.product_description}
                                            </p>
                                        </div>
                                        <div style={{
                                            textAlign: 'right',
                                            marginLeft: '1rem'
                                        }}>
                                            <div style={{
                                                color: 'white',
                                                fontSize: '2rem',
                                                fontWeight: 'bold',
                                                lineHeight: '1'
                                            }}>
                                                ${price}
                                            </div>
                                            <div style={{
                                                color: '#b0b0b0',
                                                fontSize: '0.9rem'
                                            }}>
                                                /{product.interval}
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.5rem',
                                        marginBottom: '1.5rem'
                                    }}>
                                        <div style={{
                                            width: '8px',
                                            height: '8px',
                                            backgroundColor: '#00ff88',
                                            borderRadius: '50%'
                                        }}></div>
                                        <span style={{color: 'white', fontSize: '0.9rem'}}>
                                            Full Access to All Premium Features
                                        </span>
                                    </div>
                                    
                                    <CheckoutButton priceId={product.price_id} cognitoUserId={form.cognitoUserId} fullName={form.name} email={form.email}/>
                                </div>
                            );
                        })}
                    </div>
                    
                    <div style={{marginTop: '1rem', textAlign: 'center'}}>
                        <div className='login-right-container-text'>Sign up with a new account <b className='login-right-container-link' onClick={() => setStage(0)}>here</b>.</div>
                        <div className='login-right-container-text'>Already have an account? Click <b className='login-right-container-link' onClick={() => setPage(0)}>here</b> to login.</div>
                        <div className='login-right-container-text'>Space-Eyes, Inc. is a US based company and only conducts business with US allies.</div>
                    </div>
                </form>
                <div className='login-right-logo'/>
            </div>
            // Removed Stage 3 - no longer needed since we removed session_id handling
        } 
    }

    return (stageSwitch());
}